import React from "react";

export default function AboutPage() {
  return (
    <div className="p-6 max-w-5xl mx-auto space-y-10">
      <section className="text-center">
        <h1 className="text-3xl font-bold mb-4">Rólunk</h1>
        <p className="text-gray-700 text-lg max-w-3xl mx-auto">
          A Solarya egy veresegyházi székhelyű technológiai bolt és webshop, amely az okos otthon eszközök, világítástechnika, szabadidős és barkácstermékek területén kínál széles választékot. Célunk, hogy ügyfeleinknek egyszerű, kényelmes és modern megoldásokat nyújtsunk otthonuk fejlesztéséhez.
        </p>
      </section>

      <section className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <img
          src="/img/bolt-kulso.webp"
          alt="Bolt képe 1"
          className="rounded-xl shadow w-full object-cover h-80"
        />
        <div className="flex items-center">
          <p className="text-gray-700 text-lg">
            Üzlethelyiségünk Veresegyház központjában található, jól megközelíthető helyen, tágas parkolóval. Modern bemutatótermünkben személyesen is megtekintheted és kipróbálhatod termékeinket.
          </p>
        </div>
      </section>

      <section className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="flex items-center">
          <p className="text-gray-700 text-lg">
            Webshopunk letisztult, átlátható felülettel készült, hogy könnyedén megtaláld, amit keresel. Házhoz szállítással és helyszíni átvétellel is segítünk, hogy a vásárlás a lehető legkényelmesebb legyen.
          </p>
        </div>
        <img
          src="/img/bolt-belso.webp"
          alt="Bolt képe 2"
          className="rounded-xl shadow w-full object-cover h-80"
        />
      </section>

      <section className="text-center text-gray-700">
        <h2 className="text-2xl font-semibold mb-2">Miért válassz minket?</h2>
        <ul className="list-disc list-inside max-w-2xl mx-auto text-left">
          <li>Minőségi, válogatott termékek</li>
          <li>Szakértő ügyfélszolgálat</li>
          <li>Gyors kiszállítás és rugalmas átvételi lehetőségek</li>
          <li>Folyamatosan bővülő kínálat</li>
          <li>Modern, megbízható vásárlási élmény</li>
        </ul>
      </section>
    </div>
  );
}
